module.exports = __webpack_public_path__ + "static/media/seriesonott.52907222.png";